import React from 'react';
import { Form, Field } from 'react-final-form';
import {
  InputGroup,
  Button,
  ControlLabel,
  FormControl,
} from 'react-bootstrap';

export const renderTextField = ({ input, label, type, meta: { touched, error, warning } }) => (
  <InputGroup>
    { label && (<ControlLabel>{label}</ControlLabel>)}
    <FormControl
      {...input}
      type={type}
      placeholder="Add a caption"
    />
  </InputGroup>
);

const PhotosForm = ({ onSubmit, initialValues, handleClose }) => (
  <Form
    onSubmit={onSubmit}
    initialValues={initialValues}
    render={({ handleSubmit, reset, submitting, pristine, errors }) => (
      <form onSubmit={handleSubmit} >
        <h4>
          <Field
            name="name"
            component={renderTextField}
            placeholder="Caption your photo"
          />
        </h4>
        <ul className="hotel-photo-tools">
          <li><Button type="submit" disabled={pristine || submitting} title="Edit"><i className="fa fa-check" /></Button></li>
          <li><Button onClick={handleClose} title="Remove"><i className="fa fa-close" /></Button></li>
        </ul>
      </form>
    )}
  />
  );

export default PhotosForm;


// WEBPACK FOOTER //
// src/routes/hotels/components/PhotoForm.js